import React, {Component} from 'react';
import {Badge, Button} from 'reactstrap';
import propTypes from 'prop-types';
import Moment from "moment"
import {Link} from "react-router-dom"

class ItemRequest extends Component {
    render() {
        const {requestAcc, handleClick} = this.props;
        const disabled = requestAcc.status !== 'pending';
        const badgeColorMap = {
            approved: 'success',
            rejected: 'danger',
            pending: 'warning',
            nothing: 'light'
        }
        const now = Moment();
        const createdTime = Moment(requestAcc.created);
        const backwardTime = Moment.duration(createdTime.diff(now));

        return (
            <tr className="ItemRequest">
                <td><Link to={'/a/users/'.concat(requestAcc.owner._id)}> {requestAcc.owner.name}</Link></td>
                <td>{requestAcc.owner.email}</td>
                <td>
                    <div className='tooltip-container'>{backwardTime.humanize(true)}
                        <span
                            className="tooltip-text">{createdTime.format('DD-MM-YYYY')}</span>
                    </div>
                </td>
                <td><Badge color={badgeColorMap[requestAcc.status]} pill>{requestAcc.status}</Badge></td>
                <td>
                    <Button color="primary" onClick={handleClick(requestAcc, 'approved')} disabled={disabled}>
                        <i className="fas fa-check"/>
                    </Button>{' '}
                    <Button color="danger" onClick={handleClick(requestAcc, 'rejected')} disabled={disabled}><i
                        className="fas fa-times"/>
                    </Button>{' '}
                </td>
            </tr>
        );
    }
}

ItemRequest.propTypes = {
    requestAcc: propTypes.object.isRequired,
    handleClick: propTypes.func.isRequired
}

export default ItemRequest;


// WEBPACK FOOTER //
// ./src/app/pages/dashboard/affiliate/request-acc/ItemRequest.js